import { Button } from "@prosolve/common-components-ui"
import { useState } from "react"
import { FaShareAlt } from "react-icons/fa"
import ShareProgramModal from "./ShareProgramModal"
import { isStarConsultation } from '../../../utils';
import useShareEvent from "./hooks/useShareEvent"

export default ({
  eventData
}) => {
  const [isShareLogisticsModalOpen, setIsShareLogisticsModalOpen] = useState()

  const isStarConsultationSession = isStarConsultation(eventData)

  const { getShareEventLinkData, getShareLogisticsLinkData } = useShareEvent()

  const showShareLogisticsModal = async () => {
    const { url, rootUrl } = (
      isStarConsultationSession ? 
        await getShareEventLinkData(eventData, true) : 
        await getShareLogisticsLinkData(eventData, true)
    )
    setIsShareLogisticsModalOpen({
      url,
      rootUrl,
      fullUrl: `http://${url}`
    })
  }
  
  return (
    <div>
      <Button
        style={{
          display: 'inline-flex',
          padding: '8px 16px',
          marginRight: '20px'
        }}
        onClick={showShareLogisticsModal}
      >
        <FaShareAlt style={{ marginRight: '10px', color: '#0280c6' }} />
        <span style={{ fontWeight: 'bold', color: '#565656' }}>{'Share Logistics'}</span>
      </Button>
      {isShareLogisticsModalOpen &&
        <ShareProgramModal 
          url={isShareLogisticsModalOpen.url}
          displayUrl={
            <a href={isShareLogisticsModalOpen.fullUrl} target='_blank' rel='noreferrer' style={{ color: '#33afe7', textDecoration: 'none' }}>
              {isShareLogisticsModalOpen.rootUrl}
            </a>
          }
          text="To allow external editing of this event for one (1) week, go to:"
          onClose={() => setIsShareLogisticsModalOpen(undefined)}
        />
      }
    </div>
  )
}